import { ValidHeimspielLineupProps } from './types'

const isValidHeimspielLineupProps = (
  props: any,
): props is ValidHeimspielLineupProps => !!props?.matchId

export { isValidHeimspielLineupProps }
